/** Intent-preservation for invite deep-links across the auth gate.
 *
 *  A logged-out stranger who clicks /invite/:token must NOT lose the token when
 *  the auth guard bounces them to /login. We capture the token, carry it through
 *  login/registration, then route back and redeem it. These are the two pure
 *  decisions that logic hinges on — kept here so they can be tested without a DOM.
 */

/** If a path is an invite deep-link, the token to redeem after auth; else null. */
export function pendingInviteFromPath(pathname: string): string | null {
  const m = pathname.match(/^\/invite\/([^/]+)\/?$/)
  return m ? decodeURIComponent(m[1]) : null
}

/** Where to send a user the moment they authenticate: a pending invite wins so
 *  it is actually redeemed, then whatever protected page they were reaching for,
 *  else the app home. Never routes back to /login (that would loop the gate). */
export function postAuthDestination(opts: {
  pendingInvite?: string | null
  from?: string | null
}): string {
  if (opts.pendingInvite) return `/invite/${encodeURIComponent(opts.pendingInvite)}`
  if (opts.from && opts.from !== '/login') return opts.from
  return '/home'
}
